import React from "react";
import Seo from "../../../shared/ui/Seo";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import BottomFooter from "../../../shared/layout/BottomFooter";
import Footer from "../../../shared/layout/Footer";
import { CartProvider } from "../../cart/context/CartContext";
import ProductList from "../components/ProductList";

const ProductSearchPage = () => {
    return (
        <CartProvider>
          <Seo title="Product Search" noindex />
        <ColorInit color={'bigmall'} />

        <ScrollToTop smooth color='#ef253c' />

        <Header />
        <div className="container container-lg">
        <ProductList pageSize={18} showLoadMore={false} />
        </div>
        <Footer />

        <BottomFooter />
        </CartProvider>
    );
    };

export default ProductSearchPage;
